/* src/app/selected-layers-detail-view/selected-layers-detail-view.component.css */
.legendContainer {
  position: relative;
  width: 100%;
  height: 100%;
  padding-right: 0;
  padding-bottom: 80px !important;
}
.legendScrollDiv {
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto !important;
  overflow-x: hidden;
  padding-right: 0px !important;
}
.selectedLayesSideTree {
  height: 100%;
  overflow: hidden;
  flex-direction: column;
}
div.legendTitle {
  font-size: 18px;
  color: #9b9b9b;
  background-color: #f7f7f7;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left;
}
.closeBar {
  position: absolute;
  bottom: 0px;
  z-index: 100;
  height: 45px;
  border-top: 1px solid #d3d3d3;
  width: 100%;
  cursor: pointer;
  background-color: white;
}
.closeBar img {
  position: absolute;
  bottom: 15px;
  left: 20px;
  height: 15px;
  width: 15px;
}
.openBar {
  display: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 999;
}
.legendItemHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 2px 8px 2px 10px;
  line-height: 1.2;
  font-size: 15px;
  color: rgb(73, 73, 73);
}
.legendItemHeader .legendLabel {
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}
.legendItemHeader > :first-child {
  flex: 1;
  white-space: normal;
  overflow-wrap: anywhere;
}
.legendItemBody {
  padding: 0 0 6px 10px;
  margin: 0;
}
.controlsDiv {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}
.legendExport {
  display: inline-flex;
  gap: 4px;
  flex-shrink: 0;
}
.legendItem {
  border-bottom: 1px solid #e6e9ef;
}
.legendItem:last-child {
  border-bottom: none;
}
.legendItemBody {
  padding: 5px;
  padding-left: 10px;
}
.aToggleButton {
  color: gray;
  cursor: pointer;
  height: 15px;
  padding: 0px !important;
  padding-right: -25px !important;
  vertical-align: middle !important;
}
:host ::ng-deep span.ui-button-text.ui-unselectable-text {
  padding: 0px !important;
}
.aToggleButton2 {
  background-color: white;
  color: gray;
  cursor: pointer;
  height: 15px;
  padding: 0px !important;
  padding-left: 5px !important;
  padding-right: 10px !important;
  vertical-align: middle !important;
}
.btnholder {
  width: 100%;
  height: 25px;
}
.activeLayer {
  background-color: white;
}
.notActiveLayer {
  z-index: 999;
}
img {
  z-index: 1;
}
.legendItem img {
  opacity: 0.75;
}
:host ::ng-deep .aToggleButton .ui-togglebutton {
  color: gray !important;
  background-color: transparent !important;
  box-shadow: none !important;
  width: 32px;
}
.layerlengend {
  margin-top: 5px;
  border: 1px solid gray;
  border-radius: 5px;
  padding: 5px;
}
:host ::ng-deep .aToggleButton .ui-state-active,
.ui-corner-all,
.ui-state-default {
  color: gray !important;
  border: none !important;
  background-color: transparent !important;
}
:host ::ng-deep .legendScrollDiv::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #F5F5F5;
  border-radius: 10px;
}
:host ::ng-deep .legendScrollDiv::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}
:host ::ng-deep .legendScrollDiv::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #FFF;
  background-image: -webkit-linear-gradient(top, #eff1f2 0%, #d7dee0 50%, #cbd1d3 51%, #bec4c6 100%);
}
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button {
  padding: 0 !important;
  width: 28px !important;
  height: 18px !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: gray !important;
}
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button.p-highlight,
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button:active,
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button:hover {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: gray !important;
}
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button .p-button-icon {
  color: inherit !important;
  font-size: 14px;
  margin: 0 !important;
}
:host ::ng-deep .selectedLayesSideTree .p-button:focus,
:host ::ng-deep .selectedLayesSideTree .p-togglebutton:focus,
:host ::ng-deep .selectedLayesSideTree .p-button:focus-visible,
:host ::ng-deep .selectedLayesSideTree .p-togglebutton:focus-visible,
:host ::ng-deep .selectedLayesSideTree .p-focus,
:host ::ng-deep .selectedLayesSideTree .p-button.p-focus {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .selectedLayesSideTree .p-ink {
  display: none !important;
}
.selectedLayesSideTree .aToggleButton2 {
  background: transparent;
  border: 0;
  box-shadow: none;
  outline: none;
}
:host ::ng-deep .selectedLayesSideTree *:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .selectedLayesSideTree .aToggleButton .p-button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  min-width: 0 !important;
  width: 28px !important;
  height: 18px !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button:hover,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button:active,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button:focus,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button:focus-visible,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-togglebutton.p-button.p-highlight {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  outline: none !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-button-icon-only,
:host ::ng-deep .selectedLayesSideTree .iconBtn.p-button-rounded {
  border-radius: 0 !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn .p-button-icon {
  color: inherit !important;
  margin: 0 !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn .p-ripple-element,
:host ::ng-deep .selectedLayesSideTree .iconBtn .p-ink {
  display: none !important;
}
:host ::ng-deep .selectedLayesSideTree .iconBtn,
:host ::ng-deep .selectedLayesSideTree .iconBtn * {
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}
:host ::ng-deep .iconBtn.p-button {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  padding: 0 !important;
}
:host ::ng-deep .iconBtn .p-button-icon {
  font-size: 12px !important;
}
.aToggleButton2 {
  font-size: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}
.legendLabel {
  flex: 1;
}
.selectedLayesSideTree {
  --primary-color: #6b7280;
  --primary-color-text: #6b7280;
}
.legendExportBtn {
  padding: 1px 4px;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 1.5;
  border: 1px solid #d5dae1;
  border-radius: 2px;
  background: #fff;
  color: #7a8290;
  cursor: pointer;
}
.legendExportBtn:hover {
  background: #f2f5f8;
  border-color: #b8c0ca;
  color: #4a4a4a;
}
.legendExportBtn:focus,
.legendExportBtn:focus-visible {
  outline: none;
  box-shadow: none;
}
:host ::ng-deep .selectedLayesSideTree .controlsDiv p-togglebutton,
:host ::ng-deep .selectedLayesSideTree .controlsDiv p-toggle-button {
  display: inline-flex !important;
  align-items: center !important;
  width: 20px !important;
  min-width: 20px !important;
  height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 0 !important;
}
/*# sourceMappingURL=selected-layers-detail-view.component.css.map */
